'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyShare = exports.QQShare = exports.WeiBoShare = exports.Tracker = exports.WeiXinShare = exports.DingShare = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.online = online;
exports.offline = offline;

var _react = require('react');

var _tracker = require('./tracker');

var _tracker2 = _interopRequireDefault(_tracker);

var _aps = require('@ali/aps');

require('@ali/aps/dist/css/aps.css');

require('./index.less');

var _qrCode = require('./qr-code');

var ShareComponent = _interopRequireWildcard(_qrCode);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// const { Util: { timer } } = window.$ACE;


var DingShare = exports.DingShare = ShareComponent.DingShare;
var WeiXinShare = exports.WeiXinShare = ShareComponent.WeiXinShare;

var timer = function timer(time, cb) {
  var target = new Date(time);
  var flag = Date.now() >= target;
  if (!flag) {
    var interval = setInterval(function () {
      if (Date.now() >= target) {
        cb();
        clearInterval(interval);
      }
    }, 1000);
  } else {
    cb();
  }
  return flag;
};
// 上线组件
function online(time) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var Offline = function (_BaseComponent) {
      _inherits(Offline, _BaseComponent);

      function Offline(props) {
        _classCallCheck(this, Offline);

        var _this = _possibleConstructorReturn(this, (Offline.__proto__ || Object.getPrototypeOf(Offline)).call(this, props));

        _this.state = {
          component: null
        };
        return _this;
      }

      _createClass(Offline, [{
        key: 'componentDidMount',
        value: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _this2 = this;

            var isArrived;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    isArrived = timer(time, function () {
                      console.log('到达上线时间', time);
                      _this2.setState({
                        component: factory(_this2.props)
                      });
                    });

                    if (!isArrived) {
                      console.log('未到上线时间');
                    }

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function componentDidMount() {
            return _ref.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: 'render',
        value: function render() {
          return this.state.component;
        }
      }]);

      return Offline;
    }(BaseComponent);

    return Offline;
  };
}
// 下线组件
function offline(time) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var Offline = function (_BaseComponent2) {
      _inherits(Offline, _BaseComponent2);

      function Offline(props) {
        _classCallCheck(this, Offline);

        var _this3 = _possibleConstructorReturn(this, (Offline.__proto__ || Object.getPrototypeOf(Offline)).call(this, props));

        _this3.state = {
          component: null
        };
        return _this3;
      }

      _createClass(Offline, [{
        key: 'componentDidMount',
        value: function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var _this4 = this;

            var isArrived;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    isArrived = timer(time, function () {
                      console.log('到达下线时间', time);
                      _this4.setState({
                        component: null
                      });
                    });

                    if (!isArrived) {
                      console.log('未到下线时间');
                      this.setState({
                        component: factory(this.props)
                      });
                    }

                  case 2:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function componentDidMount() {
            return _ref2.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: 'render',
        value: function render() {
          return this.state.component;
        }
      }]);

      return Offline;
    }(BaseComponent);

    return Offline;
  };
}
var Tracker = exports.Tracker = _tracker2.default;

var WeiBoShare = exports.WeiBoShare = function (_Component) {
  _inherits(WeiBoShare, _Component);

  function WeiBoShare() {
    _classCallCheck(this, WeiBoShare);

    return _possibleConstructorReturn(this, (WeiBoShare.__proto__ || Object.getPrototypeOf(WeiBoShare)).apply(this, arguments));
  }

  _createClass(WeiBoShare, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      return React.createElement(
        'div',
        { className: 'share-button-wrapper', onClick: function onClick() {
            var shareInstance = window.$ACE.Share.create(_extends({}, _this6.props));
            var PC = shareInstance.createPC();
            window.open(PC.weibo());
          } },
        this.props.children
      );
    }
  }]);

  return WeiBoShare;
}(_react.Component);

var QQShare = exports.QQShare = function (_Component2) {
  _inherits(QQShare, _Component2);

  function QQShare() {
    _classCallCheck(this, QQShare);

    return _possibleConstructorReturn(this, (QQShare.__proto__ || Object.getPrototypeOf(QQShare)).apply(this, arguments));
  }

  _createClass(QQShare, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      return React.createElement(
        'div',
        { className: 'share-button-wrapper', onClick: function onClick() {
            var shareInstance = window.$ACE.Share.create(_extends({}, _this8.props));
            var PC = shareInstance.createPC();
            window.open(PC.qq());
          } },
        this.props.children
      );
    }
  }]);

  return QQShare;
}(_react.Component);

var CopyShare = exports.CopyShare = function (_Component3) {
  _inherits(CopyShare, _Component3);

  function CopyShare(props) {
    _classCallCheck(this, CopyShare);

    var _this9 = _possibleConstructorReturn(this, (CopyShare.__proto__ || Object.getPrototypeOf(CopyShare)).call(this, props));

    _this9.state = {
      visible: false
    };
    return _this9;
  }

  _createClass(CopyShare, [{
    key: 'render',
    value: function render() {
      var _this10 = this;

      return React.createElement(
        'div',
        { className: 'share-button-wrapper', onClick: function onClick() {
            var shareInstance = window.$ACE.Share.create(_extends({}, _this10.props));
            var PC = shareInstance.createPC();
            PC.copyLink().then();
            _this10.setState({
              visible: true
            });
            setTimeout(function () {
              _this10.setState({
                visible: false
              });
            }, 2000);
          } },
        React.createElement(
          _aps.Tooltip,
          {
            visible: this.state.visible,
            trigger: this.props.children
          },
          '\u590D\u5236\u6210\u529F\uFF0C\u5FEB\u53BB\u5206\u4EAB\u5427~'
        )
      );
    }
  }]);

  return CopyShare;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/react-util/lib/index.js
// module id = 225
// module chunks = 0 1